import axios from 'axios'

export async function getRouterBySerial(serialNumber) {
    return axios
        .get(
            `${process.env.API_URL}/routers/serial/${encodeURIComponent(
                serialNumber
            )}`
        )
        .then(response => response.data)
        .catch(error => {
            if (error.response?.status === 404) {
                return null
            }
            throw error
        })
}
